import { Adsense } from "@ctrl/react-adsense";
import { Link } from "@remix-run/react";
import { Wrapper } from "../components/wrapper";

export default function Sobre(): JSX.Element {
  return (
    <Wrapper className="pt-6 md:pt-20 md:pb-52 pb-12 flex flex-col gap-6">
      <h1 className="text-2xl font-semibold text-primary-900">
        Sobre o HelpSaúde
      </h1>
      <div className="flex flex-col gap-6 md:flex-row md:justify-stretch">
        <div className="flex-1 text-sm font-normal text-neutral-900 px-6 py-6 flex flex-col gap-4 bg-primary-50 rounded-3xl">
          <h2 className="text-xl font-medium text-primary-700">
            O que é o HelpSaúde?
          </h2>
          <p>
            Sobre o HelpSaúde O que é o HelpSaúde? Para que o HelpSaúde serve?
            HelpSaúde é uma plataforma que une pacientes a médicos, dentistas,
            hospitais, clínicas e demais prestadores de serviços médicos.
            Possuímos a maior base de dados do Brasil, com mais de um milhão de
            prestadores cadastrados. Nosso serviço é 100% gratuito para os
            pacientes. Os profissionais e Estabelecimentos de saúde podem
            utilizar o HelpSaúde para conquistar novos pacientes. Não temos
            interesse em influenciar nas escolhas que os usuários fazem e apenas
            listamos prestadores contidos em nosso banco de dados. Não somos
            prestadores de saúde, não oferecemos conselhos muito menos
            diagnósticos médicos. O sistema de busca funciona de acordo com as
            palavras digitadas pelo usuário, que pode especificar um ou vários
            dos seguintes parâmetros: nome do profissional ou clínica, tipo
            (Exemplos: médico ou dentista); plano de saúde; especialidade. Basta
            selecionar o que deseja encontrar e clicar em &quot;Buscar&quot;.
            Exemplos: Angiologista em Salvador Tempo Saúde Cardiologista em São
            Paulo Dentista em Campinas Dermatologista em Belo Horizonte Sul
            América
          </p>
        </div>
        <div className="py-4">
          <Adsense
            client="ca-pub-9847031185780341"
            slot="5049161324"
            style={{ display: "block" }}
            responsive="true"
            format="auto"
          />
        </div>
        <div className="flex-1 text-sm font-normal text-neutral-900 px-6 py-6 flex flex-col gap-4 bg-primary-50 rounded-3xl">
          <h2 className="text-xl font-medium text-primary-700">
            Para que o HelpSaúde serve?
          </h2>
          <div className="flex flex-col gap-4">
            <p>
              O sistema de busca funciona de acordo com as palavras digitadas
              pelo usuário, que pode especificar um ou vários dos seguintes
              parâmetros: nome do profissional ou clínica, tipo (Exemplos:
              médico ou dentista); plano de saúde; especialidade.
            </p>
            <p>
              Basta selecionar o que deseja encontrar e clicar em
              &quot;Buscar&quot;.
            </p>
            <p>Exemplos:</p>
            <p className="flex flex-col text-primary-600 text-sm font-medium">
              <Link
                className=""
                to="/angiologista/tempo-saude-seguradora-s.a/ba/salvador"
              >
                Angiologista em Salvador Tempo Saúde
              </Link>
              <Link to="/cardiologista/sp/sao-paulo">
                Cardiologista em São Paulo
              </Link>
              <Link to="/dentista/sp/campinas">Dentista em Campinas</Link>
              <Link to="/dermatologista/sul-america-saude/mg/belo-horizonte">
                Dermatologista em Belo Horizonte Sul América
              </Link>
            </p>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
